
import React from 'react';

const features = [
  {
    icon: 'ri-lock-line',
    title: 'Confidential Client Referrals',
    description:
      "Your clients' information is handled with the highest level of discretion and privacy throughout the entire process.",
  },
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Instant Case Confirmation',
    description:
      'Receive immediate confirmation when your referral is accepted, so you always know the status of every case.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Track Resolution Progress Live',
    description:
      'Monitor every step of the resolution process in real-time through your dedicated broker portal dashboard.',
  },
  {
    icon: 'ri-team-line',
    title: 'Dedicated Support Team',
    description:
      'Get direct access to your assigned team of specialists who handle your referrals with expert care.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Competitive Commissions',
    description:
      'Earn top-tier commissions on every successful referral. We reward our partners generously for their trust.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Proven Track Record',
    description:
      'Over two decades of successfully resolving cases and building lasting relationships with brokers nationwide.',
  },
];

export default function Features() {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-50 text-blue-600 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Broker Portal Features
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            Everything You Need to <strong>Earn More</strong>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto leading-relaxed">
            Our broker referral portal gives you the tools, transparency, and support to turn your dead files into
            consistent revenue.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm hover:shadow-lg hover:border-blue-200 transition-all duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-blue-50 rounded-xl mb-5 group-hover:bg-blue-600 transition-colors duration-300">
                <i
                  className={`${feature.icon} text-2xl text-blue-600 group-hover:text-white transition-colors duration-300`}
                  aria-hidden="true"
                ></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
